// extracted by mini-css-extract-plugin
export var main = "Subheading-module--main--ISIkM";
export var primary = "Subheading-module--primary--rFC26";
export var secondary = "Subheading-module--secondary--YkgwM";